<script>
import { layoutMethods } from "@/state/helpers";
import { menuItems } from "./horizontal-menu";
import { LogLevel, HubConnectionBuilder } from "@microsoft/signalr";
import { cloneDeep } from "lodash";
import PrintOptions from "@/components/modals/print-options.vue";

export default {
    components: {
        PrintOptions
    },
    data() {
        return {
            menuItems: menuItems,
        };
    },
    async mounted() {
        var links = document.getElementsByClassName("side-nav-link-ref");
        var matchingMenuItem = null;
        for (var i = 0; i < links.length; i++) {
            if (window.location.pathname === links[i].pathname) {
                matchingMenuItem = links[i];
                break;
            }
        }

        if (matchingMenuItem) {
            matchingMenuItem.classList.add("active");
            var parent = matchingMenuItem.parentElement;

            /**
             * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
             * We should come up with non hard coded approach
             */

            if (parent) {
                parent.classList.add("active");
                const parent2 = parent.parentElement;
                if (parent2) {
                    parent2.classList.add("active");
                    const parent3 = parent2.parentElement;
                    if (parent3) {
                        parent3.classList.add("active");
                        const parent4 = parent3.parentElement;
                        if (parent4) {
                            parent4.classList.add("active");
                            const parent5 = parent4.parentElement;
                            if (parent5) {
                                parent5.classList.add("active");
                                const parent6 = parent5.parentElement;
                                if (parent6) {
                                    parent6.classList.add("active");
                                }
                            }
                        }
                    }
                }
            }
        }
        this.changeMenuOPCRWFP();
        this.changeMenuPMEPMT();
        this.attachedDUNotifications();
        this.attachedDepartmentNotifications();
        this.attachedFinanceNotifications();
        await this.$store.dispatch("notification/GetMyNotif").then((res) => {
            res.data.forEach((item) => {
                item.returnDate = this.diffDate(item.dateTime);
                item.clientDate = item.dateTime;
                item.showDeleteOption = false;
                item.searchList = `${item.title} ${item.message}`
            });
            this.$store.commit("notification/SET_NOTIFICATIONS", res.data)
        });
        // let accessToken = localStorage.getItem("accessToken");
        let connection = new HubConnectionBuilder()
            .withUrl(
                this.$store.state.notification.hubConnection + "notificationhub",
                // { accessTokenFactory: () =>  accessToken}
            )
            .configureLogging(LogLevel.None)
            .build();
        connection.onclose((error) => {
            if (error) {
                if (error.statusCode === 401) {
                    setTimeout(() => {
                        connection = new HubConnectionBuilder()
                            .withUrl(
                                this.$store.state.notification.hubConnection + "notificationhub",
                                // { accessTokenFactory: () => localStorage.getItem("accessToken") }
                            )
                            .configureLogging(LogLevel.None)
                            .build();
                        this.startConnection(connection);
                    }, 5000);
                }
                else {
                    setTimeout(() => this.startConnection(connection), 5000);
                }
            }
        });

        connection.on("notification", (message) => {
            let data = cloneDeep(message);
            data.showDeleteOption = false;
            data.clientDate = this.getDate(new Date());
            data.returnDate = this.diffDate(data.clientDate);
            this.$store.commit("notification/ADD_NOTIFICATION", data);
            this.showNotification(data);
        });
        connection.on("ClearLocalStorage", () => {
            localStorage.clear();
            this.$router.push("/login");
        });
        
        this.startConnection(connection);
    },
    methods: {
        ...layoutMethods,
        /**
         * Menu clicked show the submenu
         */
        startConnection(connection) {
            connection.start()
        },
        async showNotification(data) {
            const showNotification = () => {
                // create a new notification
                const notification = new Notification(data.title, {
                    body: data.description,
                    icon: "@/assets/images/logo/giams-colored.png",
                });

                // close the notification after 10 seconds
                setTimeout(() => {
                    notification.close();
                }, 5000);

                // navigate to a URL when clicked
                notification.addEventListener("click", () => {
                    notification.close();
                    window.focus();
                });
            };

            // show an error message
            const showError = () => {};

            // check notification permission
            let granted = false;

            if (Notification.permission === "granted") {
                granted = true;
            } else if (Notification.permission !== "denied") {
                let permission = await Notification.requestPermission();
                granted = permission === "granted" ? true : false;
            }

            // show notification or error
            granted ? showNotification() : showError();
        },
        onMenuClick(event) {
            event.preventDefault();
            const nextEl = event.target.nextSibling;
            if (nextEl && !nextEl.classList.contains("show")) {
                const parentEl = event.target.parentNode;
                if (parentEl) {
                    parentEl.classList.remove("show");
                }
                nextEl.classList.add("show");
            } else if (nextEl) {
                nextEl.classList.remove("show");
            }
            return false;
        },
        /**
         * Returns true or false if given menu item has child or not
         * @param item menuItem
         */
        hasItems(item) {
            return item.subItems !== undefined
                ? item.subItems.length > 0
                : false;
        },
        generatePRE(){
            this.$refs.printOpt.putOptions({
                apiUrl: window.IS_SCHOOL ? 'api/Report/PrePlanning/PRE/Summary' : 'api/Report/PrePlanning/AIP',
                routeVariables: [this.$store.state.data.cycle]
            })
            this.$bvModal.show('print-options-modal-1')
        },
        updateStyle(id, item){
            let doc = document.getElementById(id);
            if(!doc) return '';
            let cRects = doc.getClientRects()[0];
            item.style = `top:${cRects.bottom}px;left:${cRects.x}px`;
        },
    },
};
</script>
<template>
    <div class="topnav">
        <div class="container-fluid">
            <nav
                class="navbar navbar-light navbar-expand-lg topnav-menu active"
            >
                <div
                    class="collapse navbar-collapse active"
                    id="topnav-menu-content"
                >
                    <ul class="navbar-nav">
                        <!-- Menu data -->

                        <template v-for="(item, index) of menuItems">
                            <li
                                class="nav-item dropdown"
                                :key="index"
                                v-if="item.display"
                                :id="item.menuID"
                            >
                                <router-link
                                    class="nav-link dropdown-toggle arrow-none topnav-comps"
                                    v-if="!item.subItems"
                                    id="topnav-components"
                                    :to="item.link"
                                    role="button"
                                >
                                    <i :class="`bx ${item.icon} me-2`"></i
                                    >{{ item.label }}
                                    <div
                                        class="arrow-down"
                                        v-if="hasItems(item)"
                                    ></div>
                                </router-link>
                                <a
                                    v-if="item.subItems"
                                    class="nav-link dropdown-toggle arrow-none topnav-comps"
                                    @click="onMenuClick($event)"
                                    :id="`topnav-components-${index}`"
                                    role="button"
                                    @mouseover="updateStyle(`topnav-components-${index}`, item)"
                                >
                                    <i :class="`bx ${item.icon} me-1`"></i>
                                    <span :id="item.elementID">{{ item.label }}</span>
                                    <div class="arrow-down"></div>
                                </a>
                                <div
                                    class="dropdown-menu adjust-height"
                                    aria-labelledby="topnav-dashboard"
                                    v-if="hasItems(item) && item.display"
                                    :style="item.style"
                                >
                                    <template
                                        v-for="(
                                            subitem, index
                                        ) of item.subItems"
                                    >
                                        <hr
                                            class="divider my-1"
                                            :key="'div-' + index"
                                            v-if="
                                                subitem.divider &&
                                                subitem.display
                                            "
                                        />
                                        <template v-if="subitem.click">
                                            <a href="javascript:void(0);" @click="generatePRE" :key="'span' + index" class="col dropdown-item side-nav-link-ref">{{subitem.label}}</a>
                                        </template>
                                        <template v-else>
                                            <span v-if="subitem.disabled && subitem.display" :key="'span' + index" class="font-size-11 font-weight-bolder ms-2">{{subitem.label}}</span>
                                            <router-link
                                                class="
                                                    col
                                                    dropdown-item
                                                    side-nav-link-ref
                                                "
                                                :key="index"
                                                v-if="
                                                    !hasItems(subitem) &&
                                                    subitem.display &&
                                                    !subitem.divider &&
                                                    !subitem.disabled
                                                "
                                                :to="subitem.link"
                                                ><span :id="subitem.elementID">{{ subitem.label }}</span></router-link
                                            >

                                            <div
                                                class="dropdown"
                                                v-if="
                                                    hasItems(subitem) &&
                                                    subitem.display
                                                "
                                                :key="index"
                                            >
                                                <a
                                                    class="
                                                        dropdown-item
                                                        dropdown-toggle
                                                    "
                                                    href="javascript: void(0);"
                                                    @click="onMenuClick($event)"
                                                    ><span :id="subitem.elementID">{{ subitem.label }}</span>
                                                    <div class="arrow-down"></div>
                                                </a>
                                                <div class="dropdown-menu">
                                                    <template
                                                        v-for="(
                                                            subSubitem, index
                                                        ) of subitem.subItems"
                                                    >
                                                        <hr
                                                            class="divider my-1"
                                                            :key="'div-' + index"
                                                            v-if="
                                                                subSubitem.divider &&
                                                                subSubitem.display
                                                            "
                                                        />
                                                        <router-link
                                                            class="
                                                                dropdown-item
                                                                side-nav-link-ref
                                                            "
                                                            :key="index"
                                                            v-if="
                                                                !hasItems(
                                                                    subSubitem
                                                                ) &&
                                                                subSubitem.display &&
                                                                !subSubitem.divider
                                                            "
                                                            :to="subSubitem.link"
                                                            ><span :id="subSubitem.elementID">{{
                                                                subSubitem.label
                                                            }}</span></router-link
                                                        >
                                                        <div
                                                            class="dropdown"
                                                            v-if="
                                                                hasItems(
                                                                    subSubitem
                                                                ) &&
                                                                subSubitem.display
                                                            "
                                                            :key="index"
                                                        >
                                                            <a
                                                                class="
                                                                    dropdown-item
                                                                    dropdown-toggle
                                                                "
                                                                href="javascript: void(0);"
                                                                @click="
                                                                    onMenuClick(
                                                                        $event
                                                                    )
                                                                "
                                                                >{{
                                                                    subSubitem.label
                                                                }}
                                                                <div
                                                                    class="
                                                                        arrow-down
                                                                    "
                                                                ></div>
                                                            </a>
                                                            <div
                                                                class="
                                                                    dropdown-menu
                                                                "
                                                            >
                                                                <router-link
                                                                    v-for="(
                                                                        subSubSubitem,
                                                                        index
                                                                    ) of subSubitem.subItems"
                                                                    class="
                                                                        dropdown-item
                                                                        side-nav-link-ref
                                                                    "
                                                                    :key="index"
                                                                    :to="
                                                                        subSubSubitem.link
                                                                    "
                                                                    routerLinkActive="active"
                                                                    >{{
                                                                        subSubSubitem.label
                                                                    }}</router-link
                                                                >
                                                            </div>
                                                        </div>
                                                    </template>
                                                </div>
                                            </div>
                                        </template>
                                    </template>
                                </div>
                            </li>
                        </template>
                    </ul>
                </div>
            </nav>
        </div>
        <print-options ref="printOpt" :propId="1"></print-options>
    </div>
</template>